// @flow
import * as R from "ramda"

import type { PassengerValues } from "booking/scenes/ReservationForm/services/fields/passengersFields"
import type { Combinations, BaggageCategoryApi } from "./mapperBaggage"

export const setPassengerToCategory = (
  type: BaggageCategoryApi,
  combination: number,
  passengerIndex: number,
) => (combinations: Combinations) => {
  // $FlowFixMe
  const currentPassengers = R.pathOr([], [type, combination, "passengers"], combinations)
  return R.assocPath(
    [type, combination, "passengers"],
    [...currentPassengers, passengerIndex],
    combinations,
  )
}

export const hasPassengers = (combination: { passengers?: number[] }) =>
  combination.passengers ? combination.passengers.length > 0 : false

const mapCombinationToSaveBooking = (combination: { passengers?: number[] }) => ({
  combination: R.omit(["passengers"], combination),
  passengers: combination.passengers || [],
})

const flattenCombinations = combs => [...combs.hand_bag, ...combs.hold_bag]

export const addPassengersToCombinations = (passengersValues: PassengerValues[]) => (
  combinations: Combinations,
) =>
  passengersValues.reduce(
    (acc, passengerValues, index) =>
      R.compose(
        setPassengerToCategory("hand_bag", passengerValues.baggage.handBag, index),
        setPassengerToCategory("hold_bag", passengerValues.baggage.holdBag, index),
      )(acc),
    combinations,
  )

export const mapperSaveBooking = (
  passengersValues: PassengerValues[],
  combinations: Combinations,
) =>
  R.compose(
    // $FlowFixMe
    R.map(mapCombinationToSaveBooking),
    R.filter(hasPassengers),
    flattenCombinations,
    addPassengersToCombinations(passengersValues),
  )(combinations)
